<template>
    <hts-drawer
        v-model="visible"
        :submit="handleSubmitFormEditVehicle"
        :title="$t('labels.editVehicle')"
        size="large"
        :rules="rulesEditVehicle"
        @close="closeOverSide">
        <hts-card :title="$t('labels.generalInformation')">
            <div
                v-if="dataFormEditVehicle.type === 1"
                class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-select-cooperator
                    v-model="dataFormEditVehicle.fleetVehicle"
                    :name="dataFormEditVehicle.fleetVehicleDetail.name"
                    required
                    prop="fleetVehicle"
                    type-cooperator="PARTNER"
                    :label="$t('labels.fleetVehicle')"
                    @change="handleChangeVehicle" />
                <hts-form-input
                    v-model="dataFormEditVehicle.licensePlate"
                    :label="$t('labels.vehicleModule.licensePlate')"
                    :required="true"
                    :color="props.color"
                    name="vehicleModule.licensePlate"
                    prop="vehicleModule.licensePlate" />
            </div>
            <template v-if="dataFormEditVehicle.type === 0">
                <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                    <div class="flex">
                        <hts-form-checkbox
                            v-model="dataFormEditVehicle.containerType"
                            :items="[{ label: $t('labels.vehicleModule.containerType'), value: false }]" />
                        <hts-tooltip class="mt-1">
                            <div>
                                <span class="font-bold">
                                    {{ $t('labels.containerTypeDetail') }}
                                </span>
                            </div>
                            <template #reference>
                                <hi-information-circle-icon class="flex items-center text-green-500 w-6 h-6" />
                            </template>
                        </hts-tooltip>
                    </div>

                    <hts-form-checkbox
                        v-model="dataFormEditVehicle.isGenset"
                        :items="[{ label: $t('labels.vehicleModule.useGenset'), value: false }]" />

                    <hts-form-input
                        v-model="dataFormEditVehicle.licensePlate"
                        :label="$t('labels.vehicleModule.licensePlate')"
                        :required="true"
                        :color="props.color"
                        name="vehicleModule.licensePlate"
                        prop="vehicleModule.licensePlate" />
                    <hts-form-input
                        v-model="dataFormEditVehicle.manufacture"
                        :label="$t('labels.vehicleModule.manufacture')"
                        :color="props.color"
                        name="vehicleModule.manufacture"
                        prop="vehicleModule.manufacture" />
                    <hts-form-input
                        v-model="dataFormEditVehicle.vehicleLoad"
                        :label="$t('labels.vehicleModule.category.vehicleLoad')"
                        :color="props.color"
                        type="number"
                        name="vehicleModule.category.vehicleLoad"
                        prop="vehicleModule.category.vehicleLoad"
                        @change="handleInputVehicleLoad">
                        <template #custom>
                            <hts-tooltip>
                                <div>
                                    <span class="font-bold">
                                        {{ $t('labels.vehicleModule.subcriptionVehicleLoad') }}
                                    </span>
                                </div>
                                <template #reference>
                                    <hi-information-circle-icon class="flex items-center text-green-500 w-6 h-6" />
                                </template>
                            </hts-tooltip>
                        </template>
                    </hts-form-input>

                    <hts-form-input
                        v-model="dataFormEditVehicle.weight"
                        :label="$t('labels.vehicleModule.weight')"
                        type="number"
                        :color="props.color"
                        name="vehicleModule.weight"
                        prop="vehicleModule.weight" />
                    <hts-form-date
                        v-model="dataFormEditVehicle.expiredYear"
                        :label="$t('labels.vehicleModule.expiredYear')"
                        :color="props.color"
                        type="year"
                        name="vehicleModule.expiredYear"
                        prop="vehicleModule.expiredYear"
                        @change="updateDepreciationVehicle(false)" />
                    <hts-form-input
                        v-model="dataFormEditVehicle.price"
                        :label="$t('labels.vehicleModule.price')"
                        type="number"
                        :color="props.color"
                        name="vehicleModule.price"
                        prop="vehicleModule.price" />
                    <hts-form-date
                        v-model="dataFormEditVehicle.buyingTime"
                        :label="$t('labels.vehicleModule.buyingTime')"
                        :color="props.color"
                        type="year"
                        name="vehicleModule.buyingTime"
                        prop="vehicleModule.buyingTime"
                        @change="updateDepreciationVehicle(false)" />
                    <hts-form-select
                        v-model="dataFormEditVehicle.licenseType"
                        :label="$t('labels.driverModule.licenseType')"
                        :items="license() || []"
                        key-id="key"
                        key-label="key"
                        key-tooltip="keyDes"
                        :color="props.color"
                        name="driverModule.licenseType"
                        prop="driverModule.licenseType"
                        @change="handelChangeLicenseType" />

                    <div>
                        <hts-form-select
                            v-model="dataFormEditVehicle.driver"
                            v-model:text="dataFormEditVehicle.driverName"
                            :param-prepare="dataFormEditVehicle.licenseType"
                            :label="$t('labels.primaryDriver')"
                            name="driver"
                            prop="driver"
                            key-id="_id"
                            key-label="driverDetail"
                            :disabled="dataFormEditVehicle.licenseType ? false : true"
                            :query="findDrivers" />

                        <hts-form-select
                            v-model="dataFormEditVehicle.coDriver"
                            v-model:text="dataFormEditVehicle.coDriverName"
                            :param-prepare="dataFormEditVehicle.licenseType"
                            :label="$t('labels.coDriver')"
                            name="coDriver"
                            prop="coDriver"
                            key-id="_id"
                            key-label="driverDetail"
                            :disabled="dataFormEditVehicle.licenseType ? false : true"
                            :query="findDrivers" />
                    </div>

                    <div>
                        <hts-select-vehicle-parking
                            v-model="dataFormEditVehicle.parkingNodeId"
                            v-model:text="dataFormEditVehicle.parkingNodeName"
                            required
                            prop="parkingNodeId"
                            name="parkingLot" />

                        <hts-select-tracking-gps
                            v-model="dataFormEditVehicle.gpsTrackingType"
                            required
                            prop="gpsTrackingType"
                            name="gpsTrackingType"
                            :label="$t('labels.gpsTrackingType')" />
                    </div>
                </div>
            </template>
        </hts-card>
        <div
            v-if="dataFormEditVehicle.type === 0"
            class="mt-1.5">
            <hts-card>
                <template #title>
                    <h3 class="title">
                        <span class="label">
                            {{ $t('labels.vehicleModule.tollStationInformation') }}
                        </span>
                    </h3>
                </template>
                <div class="color-theme size-default hts-form-input">
                    <div
                        v-if="dataFormEditVehicle.tollStation && dataFormEditVehicle.tollStation.length > 0"
                        class="grid grid-cols-1 gap-4 my-3">
                        <div
                            v-for="(item, index) in dataFormEditVehicle.tollStation"
                            :key="index">
                            <hts-form-disclosure
                                color="main"
                                size="large"
                                :is-have-children="false"
                                :is-have-remove-icon="true"
                                :is-edit="item.newTollStation"
                                :disabled="props.disabled"
                                @remove="handleRemove(index)"
                                @edit="handleEditTollStation(index, item)">
                                <template #reference>
                                    <div class="grid grid-cols-1">
                                        <span class="mt-2 text-base">
                                            {{ $t('labels.vehicleModule.tollStationName') }}: {{ item?.tollStationName || item?.tollStationDetail?.location?.locationName }}
                                        </span>
                                        <span class="mt-2 text-base">
                                            {{ $t('labels.calculatedBy') }}:
                                            {{ item.calculatedBy === 'MONTH' ? $t('labels.month') : item.calculatedBy === 'QUARTER' ? $t('labels.quarter') : '' }}
                                        </span>
                                        <span class="mt-2 text-base">
                                            {{ $t('labels.from') }}: {{ $formatters.date(item.from || 0) }}
                                        </span>
                                        <span class="mt-2 text-base">
                                            {{ $t('labels.to') }}: {{ $formatters.date(item.to || 0) }}
                                        </span>
                                    </div>
                                </template>
                            </hts-form-disclosure>
                        </div>
                    </div>
                    <div class="flex items-center justify-center mt-2">
                        <div
                            class="h-7 w-7 mt-3 cursor-pointer border-2 border-orange-500 rounded-full flex items-center justify-center"
                            @click="handleOpenPopupTollStation">
                            <hi-plus-icon class="h-5 w-5 fill-orange-700" />
                        </div>
                    </div>
                </div>
            </hts-card>

            <hts-card
                v-if="checkPermission(layoutPermissions.vehicle_administration)"
                :color="highlightInput">
                <template #title>
                    <div>
                        <div class="w-full flex justify-start my-2">
                            <span class="mr-4">
                                {{ $t('labels.vehicleModule.administration') }}
                            </span>

                            <hi-arrow-path-icon
                                class="w-6 h-6"
                                :class="{
                                    'text-warning-500': !dataFormEditVehicle.approvedByManagement,
                                    'text-success-500': dataFormEditVehicle.approvedByManagement
                                }" />

                            <p
                                v-if="!dataFormEditVehicle.approvedByManagement"
                                class="text-warning-500">
                                {{ $t('labels.waittingApprove') }}
                            </p>

                            <p
                                v-if="dataFormEditVehicle.approvedByManagement"
                                class="text-success-500">
                                {{ $t('labels.approved') }}
                            </p>
                        </div>
                    </div>
                </template>
                <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                    <hts-form-input
                        v-model="dataFormEditVehicle.fuelConsumption"
                        :label="$t('labels.vehicleModule.fuelConsumption')"
                        type="number"
                        :color="highlightInput || props.color"
                        name="vehicleModule.fuelConsumption"
                        prop="vehicleModule.fuelConsumption" />
                    <hts-form-input
                        v-model="dataFormEditVehicle.priceLiquidation"
                        :label="$t('labels.priceLiquidation')"
                        type="number"
                        :color="highlightInput || props.color"
                        name="priceLiquidation"
                        prop="priceLiquidation" />
                    <div>
                        <hts-form-input
                            v-model="dataFormEditVehicle.depreciationVehicle"
                            :label="$t('labels.vehicleModule.depreciationVehicle')"
                            type="number"
                            :color="highlightInput || props.color"
                            name="vehicleModule.depreciationVehicle"
                            prop="vehicleModule.depreciationVehicle"
                            @change="updateDepreciationVehicle(true)" />
                        <p class="text-error-500 text-xs p-0 m-0 ml-1">
                            {{ showVehicleDepreciationError ? $t('labels.vehicleModule.vehicleDepreciationError') : '' }}
                        </p>
                    </div>
                    <hts-form-input
                        v-model="dataFormEditVehicle.repairingPrice"
                        :label="$t('labels.vehicleModule.repairingPrice')"
                        type="number"
                        :color="props.color"
                        name="repairingPrice"
                        prop="repairingPrice" />
                </div>
            </hts-card>
        </div>

        <hts-card
            v-if="dataFormEditVehicle.type === 1"
            :title="$t('labels.driverInfo')">
            <div
                v-if="dataFormEditVehicle.otherCompanyDriver"
                class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-input
                    v-model="dataFormEditVehicle.otherCompanyDriver.fullName"
                    :label="$t('labels.fullName')"
                    required
                    :color="color"
                    name="fullName"
                    prop="fullName" />
                <hts-form-phone
                    v-model="dataFormEditVehicle.otherCompanyDriver.phone"
                    :label="$t('labels.phone')"
                    required
                    prop="phone"
                    name="phone"
                    @updateCode="(val) => (dataFormEditVehicle.otherCompanyDriver.phone.code = val)" />
                <hts-form-input
                    v-model="dataFormEditVehicle.otherCompanyDriver.idCardNumber"
                    :label="$t('labels.idCardNumber')"
                    required
                    :color="color"
                    name="idCardNumber"
                    prop="idCardNumber" />
            </div>
        </hts-card>
        <add-toll-station
            ref="addTollStation"
            @submit="handleAddTollStation" />

        <hts-modal
            v-model="modalConfirmDepreciationVehicle"
            :title="$t('labels.vehicleModule.vehicleDepreciationConfirm')"
            :content="$t('labels.vehicleModule.vehicleDepreciationConfirmDetail')"
            type="confirm"
            @confirm="modalConfirmDepreciationVehicle = false"
            @hide="cancelDepreciationVehicle" />

        <hts-modal
            v-model="openPopupAddCategory"
            title="Thiếu loại xe"
            :content="CContentNoVehicleCatagory" />

        <hts-modal
            v-model="openPopupCostingErrorCategory"
            :content="contentPopupAddCategory"
            @hide="() => (openPopupCostingErrorCategory = false)" />
    </hts-drawer>
</template>

<script setup lang="ts">
import AddTollStation from './add-toll-station.vue'
import form, { IVehicle } from './imports/form'
import { $api, $lodash } from '#imports'
import layoutPermissions from '@/data/permissions/layout-permissions'
import data from '@/pages/trucker-[id]/driver/ignore/imports/data'
import { checkPermission } from '@/utils/permission-check'

const { $formatters } = useNuxtApp()
const { rules } = form
const store = $store()
const { license } = data()

const route = useRoute()
const id: string = route.query.id ? String(route.query.id) : ''

const highlightInput = computed(() => {
  if (id && !dataFormEditVehicle?.approvedByManagement) {
    return 'orange'
  }
})

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 3
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['close', 'refreshDataTables'])

const dataFormEditVehicle = reactive<IVehicle>({ ...form.initFormVehicle } as IVehicle)
const visible = ref(false)
const openPopupAddCategory = ref(false)
const modalConfirmDepreciationVehicle = ref(false)
const closeOverSide = () => {
  visible.value = false
  emits('close')
}

const configCont: { [key: string]: any } = reactive({})

const openEditVehicle = async (vehicle: IVehicle) => {
  visible.value = true
  loading.value = true
  Object.assign(dataFormEditVehicle, { ...form.initFormVehicle })
  await getData(vehicle._id)
  if (dataFormEditVehicle.type === 1) {
    await getDataCooperator()
  }
  Object.assign(configCont, store.globalSettings.getGlobalSettings.configCont || {})
  // if (dataFormEditVehicle.type === 0 || (dataFormEditVehicle.typeFleetVehicle && dataFormEditVehicle.typeFleetVehicle.includes('PARTNER'))) {
  //   handleInputVehicleLoad(dataFormEditVehicle.vehicleLoad)
  // }
  nextTick(() => {
    loading.value = false
  })
}
defineExpose({
  openEditVehicle
})

const loading = ref(false)

const getData = async (id: string | undefined | String) => {
  const api = $url.vehicle.vehicle.getById
  await $api(api, { uriParams: { ID: id } }).then((data: any) => {
    const resData: any = data.data.value
    if (resData?.success) {
      Object.assign(dataFormEditVehicle, resData.data)

      delete dataFormEditVehicle.scheduleTimes
      defaultValueVehicle()
    }
  })
}

const defaultValueVehicle = () => {
  if ($lodash.isNil(dataFormEditVehicle.vehicleTypeDetail)) {
    dataFormEditVehicle.vehicleTypeDetail = {}
  }
  if ($lodash.isNil(dataFormEditVehicle.containerType) || !dataFormEditVehicle.containerType) {
    dataFormEditVehicle.containerType = false
    dataFormEditVehicle.goodsType = ['SOLID']
  }
  if ($lodash.isNil(dataFormEditVehicle.isGenset)) {
    dataFormEditVehicle.isGenset = false
  }

  // nếu management đã duyệt lấy giá trị đã lưu, chưa duyệt lấy giá trị bên loại xe

  dataFormEditVehicle.fuelConsumption = dataFormEditVehicle?.approvedByManagement
    ? dataFormEditVehicle?.fuelConsumption
    : dataFormEditVehicle?.vehicleTypeDetail?.oilMaterialAssumption

  dataFormEditVehicle.priceLiquidation = dataFormEditVehicle?.approvedByManagement
    ? dataFormEditVehicle?.priceLiquidation
    : dataFormEditVehicle?.vehicleTypeDetail?.liquidationValue

  dataFormEditVehicle.repairingPrice = dataFormEditVehicle?.approvedByManagement
    ? dataFormEditVehicle?.repairingPrice
    : dataFormEditVehicle?.vehicleTypeDetail?.repairingPrice

  vehicleCategory.value = dataFormEditVehicle?.vehicleTypeDetail
}

const contentPopupAddCategory = ref('')
const openPopupCostingErrorCategory = ref(false)

const CContentNoVehicleCatagory = computed(() => {
  return `Bạn không thể tiếp tục thêm mới xe cho xe có trọng tải ${$formatters.formatCurrency(
    dataFormEditVehicle.vehicleLoad || 0
  )} kg. Vui lòng liên hệ admin để thêm loại xe tương ứng.`
})

const handleInputVehicleLoad = $lodash.debounce(async (value: number | null) => {
  const api = $urlAdmin.vehicle.category['find-by-vehicle-tonnage']

  const data: any = await $api(api, {
    uriParams: { KEY: typeof value === 'number' ? value : typeof dataFormEditVehicle.vehicleLoad === 'number' ? dataFormEditVehicle.vehicleLoad : '' }
  })

  const resData: any = data?.data?.value

  if (resData?.success) {
    const { oilMaterialAssumption, liquidationValue, repairingPrice } = resData.data
    if ($lodash.isNil(oilMaterialAssumption) || $lodash.isNil(liquidationValue) || $lodash.isNil(repairingPrice)) {
      contentPopupAddCategory.value = `Bạn không thể tiếp tục thêm mới xe cho xe có trọng tải ${$formatters.formatCurrency(
        dataFormEditVehicle.vehicleLoad
      )} kg. Vui lòng liên hệ admin để thêm các thông tin về chi phí cho loại xe có trọng tải tương ứng.`
      vehicleCategory.value = {}
      dataFormEditVehicle.repairingPrice = null
      dataFormEditVehicle.priceLiquidation = null
      dataFormEditVehicle.fuelConsumption = null
      openPopupCostingErrorCategory.value = true
    } else {
      vehicleCategory.value = resData.data || {}
      dataFormEditVehicle.vehicleType = resData.data._id || ''
      dataFormEditVehicle.repairingPrice = repairingPrice || 0
      dataFormEditVehicle.priceLiquidation = liquidationValue || 0
      dataFormEditVehicle.fuelConsumption = oilMaterialAssumption || 0
      openPopupCostingErrorCategory.value = false
      contentPopupAddCategory.value = ''
    }
  }
}, 500)

const updateDepreciationVehicle = $lodash.debounce((depreciationVehicle?: Boolean) => {
  if (depreciationVehicle) {
    depreciationVehicleChange()
    return
  }

  if (!dataFormEditVehicle?.buyingTime || !dataFormEditVehicle?.expiredYear) {
    dataFormEditVehicle.depreciationVehicle = 1
    return
  }
  dataFormEditVehicle.depreciationVehicle = Number(dataFormEditVehicle.expiredYear) - Number(dataFormEditVehicle.buyingTime)
  if (dataFormEditVehicle.depreciationVehicle < 1) {
    dataFormEditVehicle.depreciationVehicle = 1
  }
}, 500)

const handleOpenPopupTollStation = () => {
  if (addTollStation.value) {
    addTollStation.value.open()
  }
}
const handleAddTollStation = (data: any, value: string, index: number) => {
  if (!(typeof index === 'number')) {
    data.newTollStation = true
    dataFormEditVehicle.tollStation.push(data)
  }
  if (typeof index === 'number') {
    Object.assign(dataFormEditVehicle.tollStation[index], { ...data })
  }
}
const handleRemove = (index: number) => {
  dataFormEditVehicle.tollStation.splice(index, 1)
}

const handleSubmitFormEditVehicle = async () => {
  if (dataFormEditVehicle.type === 0 && !Object.keys(vehicleCategory.value).length) {
    openPopupAddCategory.value = true
    return
  }

  if (
    $lodash.isNil(vehicleCategory.value?.oilMaterialAssumption ?? null) ||
    $lodash.isNil(vehicleCategory.value.liquidationValue ?? null) ||
    $lodash.isNil(vehicleCategory.value.repairingPrice ?? null)
  ) {
    contentPopupAddCategory.value = `Bạn không thể tiếp tục thêm mới xe cho xe có trọng tải ${$formatters.formatCurrency(
      dataFormEditVehicle.vehicleLoad
    )} kg. Vui lòng liên hệ admin để thêm các thông tin về chi phí cho loại xe có trọng tải tương ứng.`
    openPopupCostingErrorCategory.value = true
    return
  }

  if (dataFormEditVehicle.type !== 0) {
    dataFormEditVehicle.parkingNodeId = null
  }

  const api = $url.vehicle.vehicle.edit

  if (!dataFormEditVehicle.containerType) {
    dataFormEditVehicle.goodsType = []
    dataFormEditVehicle.coveringContainerLevel = ''
  }

  dataFormEditVehicle.driver = dataFormEditVehicle.driver || null
  dataFormEditVehicle.coDriver = dataFormEditVehicle.coDriver || null

  if (dataFormEditVehicle.coDriver && !dataFormEditVehicle.driver) {
    process.client && $toast().error('Vui lòng chỉ định tài xế chính trước khi chọn tài xế phụ')
    return
  }

  if (dataFormEditVehicle.driver && dataFormEditVehicle.driver === dataFormEditVehicle.coDriver) {
    process.client && $toast().error('Vui lòng chỉ định tài xế phụ khác tài xế chính')
    return
  }

  const data: any = await $api(api, {
    uriParams: { ID: dataFormEditVehicle._id },
    body: { ...dataFormEditVehicle }
  })
  const resData: any = data?.data?.value
  if (resData?.success) {
    process.client && $toast().success(resData.data)
    emits('refreshDataTables')
    emits('close')
    visible.value = false
  }
}

const vehicleCategory = ref<{ [key: string]: any }>({})

const rulesEditVehicle = computed(() => {
  const year = new Date().getFullYear()
  let data: { [key: string]: any } = {}
  if (dataFormEditVehicle.type === 0) {
    Object.assign(data, { ...rules.editVehicle })
    const buyingTime = dataFormEditVehicle.buyingTime && dataFormEditVehicle.buyingTime <= year ? dataFormEditVehicle.buyingTime : 1970
    if (data) {
      data['vehicleModule.buyingTime'] = data['vehicleModule.buyingTime'] + '|min_value:1971|max_value:' + year
      data['vehicleModule.expiredYear'] = data['vehicleModule.expiredYear'] + `|min_value:${Number(buyingTime) > 1970 ? Number(buyingTime) + 1 : 1970}`
      if (checkPermission(layoutPermissions.vehicle_administration)) {
        data['vehicleModule.fuelConsumption'] = 'required|gt:0'

        if (typeof dataFormEditVehicle.priceLiquidation === 'number' && typeof dataFormEditVehicle.price === 'number') {
          if (checkPermission(layoutPermissions.vehicle_administration)) {
            data.priceLiquidation = `required|validationCustom:${
              dataFormEditVehicle.priceLiquidation < dataFormEditVehicle.price
            }--Giá thanh lý phải nhỏ hơn giá mua`
          }

          data['vehicleModule.price'] = `required|validationCustom:${
            dataFormEditVehicle.priceLiquidation < dataFormEditVehicle.price
          }--Giá mua phải lớn hơn giá thanh lý`
        }
      }
      const maxValue = Number(dataFormEditVehicle.expiredYear) - Number(dataFormEditVehicle.buyingTime)
      if (maxValue >= 1 && dataFormEditVehicle.expiredYear && dataFormEditVehicle.buyingTime) {
        data['vehicleModule.depreciationVehicle'] = `integer|min_value:1|max_value:${maxValue}`
      } else {
        data['vehicleModule.depreciationVehicle'] = 'integer|min_value:1'
      }
    }
  } else if (dataFormEditVehicle.type === 1) {
    data = {
      'vehicleModule.licensePlate': 'required',
      fullName: 'required',
      phone: 'required',
      idCardNumber: 'required'
    }
  }
  return data
})

const showVehicleDepreciationError = computed(() => {
  if (!checkPermission(layoutPermissions.vehicle_administration)) {
    return false
  }

  const depreciationVehicle = Number(dataFormEditVehicle.expiredYear) - Number(dataFormEditVehicle.buyingTime)
  if (depreciationVehicle < 1) {
    return false
  }

  if (dataFormEditVehicle.depreciationVehicle && dataFormEditVehicle.depreciationVehicle < 1) {
    return false
  }

  if (depreciationVehicle < Number(dataFormEditVehicle.depreciationVehicle)) {
    return true
  }
  return false
})

const addTollStation = ref()

const handleEditTollStation = (index: number, data: any) => {
  if (addTollStation.value) {
    addTollStation.value.open(index, data)
  }
}

const depreciationVehicleChange = () => {
  if (!checkPermission(layoutPermissions.vehicle_administration)) {
    return
  }
  const expiredYear = Number(dataFormEditVehicle.expiredYear) || undefined
  const buyingTime = Number(dataFormEditVehicle.buyingTime) || undefined
  const depreciationVehicle = Number(dataFormEditVehicle.depreciationVehicle) || undefined

  if (typeof expiredYear !== 'number' || typeof buyingTime !== 'number' || typeof depreciationVehicle !== 'number') {
    return
  }
  if (depreciationVehicle > 0 && depreciationVehicle < expiredYear - buyingTime) {
    modalConfirmDepreciationVehicle.value = true
  }
}

const cancelDepreciationVehicle = $lodash.debounce(() => {
  const expiredYear = Number(dataFormEditVehicle.expiredYear) || 0
  const buyingTime = Number(dataFormEditVehicle.buyingTime) || 0
  dataFormEditVehicle.depreciationVehicle = expiredYear - buyingTime || 1
})

const handleChangeVehicle = (val: { [key: string]: any }) => {
  if (val.length && val[0] && val[0].type && val[0].type.length) {
    dataFormEditVehicle.typeFleetVehicle = val[0].type
    return
  }
  dataFormEditVehicle.typeFleetVehicle = null
}
const getDataCooperator = async () => {
  const api = $url.partner['get-detail']
  const data: any = await $api(api, { uriParams: { ID: dataFormEditVehicle.fleetVehicle } })
  const resData: any = data?.data?.value
  if (resData?.success) {
    dataFormEditVehicle.typeFleetVehicle = resData.data.type
  }
}

const handelChangeLicenseType = (val: any) => {
  dataFormEditVehicle.driver = null
  dataFormEditVehicle.driverName = ''
}

const findDrivers = async (s: string) => {
  const api: any = $url.driver.driver.selectByLicenseType

  const res = await $api(api, {
    query: {
      key: s,
      licenseType: dataFormEditVehicle.licenseType,
      vehicle: dataFormEditVehicle._id
    }
  })
  const resData: any = res?.data.value
  if (resData.success) {
    return resData.data
  }
  return null
}
const showDrawerAddVehicleCategory = ref()
const openAddCategory = () => {
  if (showDrawerAddVehicleCategory.value) {
    openPopupAddCategory.value = false
    showDrawerAddVehicleCategory.value.openAddCategory()
  }
}
</script>
